import {MessageFromParent} from '@stripe-internal/support-conversations-controller';

import {createIframeMessageBus} from './createIframeMessageBus';
import {createMobileMessageBus} from './createMobileMessageBus';
import {ParentMessageBus} from './ParentMessageBus';

export type ParentMessageListenerFn = (message: MessageFromParent) => void;

export function createParentMessageBus({
  audience,
  entryPoint,
  parentOrigin,
}: {
  audience?: string;
  entryPoint?: string;
  parentOrigin: string;
}): ParentMessageBus {
  if (
    [
      'mobile_ios',
      'mobile_android',
      'react_native_mobile_ios',
      'react_native_mobile_android',
      'mobile_link_ios',
      'mobile_link_android',
    ].includes(entryPoint || '')
  ) {
    return createMobileMessageBus({audience, entryPoint});
  }

  return createIframeMessageBus({
    audience,
    entryPoint,
    parentOrigin,
  });
}
